import api, { session } from 'networkapp-api-connector';

import { expireCachedCalls } from '../data/updates';
import handleLogout from '../misc/logout';

export default {
    login: function (email, password) {
        return api.session.login(email, password).then(function (user) {
            app.store.dispatch(app.actions.session.login(user));
        });
    },
    confirmPassword: function (email, password) {
        return api.session.login(email, password);
    },
    logout: function () {
        return api.session.logout();
    },
    restoreSession: function (userId, authToken) {
        return api.session.restoreSession(userId, authToken).then(function (user) {
            app.store.dispatch(
                app.actions.session.login({
                    ...user,
                    public_key: authToken,
                })
            );
        });
    },
    register: function (email, password, firstName, lastName) {
        return api.session.register(email, password, firstName, lastName).then(function (user) {
            app.store.dispatch(app.actions.session.login(user));
            return user;
        });
    },
    linkedinLogin: function (code, state, redirect_uri) {
        return api.session.linkedinLogin(code, state, redirect_uri).then(function (user) {
            app.store.dispatch(app.actions.session.login(user));
            return user;
        });
    },
    appleLogin: async function ({ code: oauth2_code, id_token: token }, { name: { firstName, lastName }, email } = { name: {} }) {
        const user = await api.session.socialLogin(api.session.SocialLoginProviders.APPLE, oauth2_code, token, { firstName, lastName, email });
        app.store.dispatch(app.actions.session.login(user));
        return user;
    },
    recoverPassword: function (email) {
        return api.session.recoverPassword(email);
    },
    getUpdates: function () {
        return api.session
            .getUpdates()
            .then((data) => expireCachedCalls(data))
            .then((data) => {
                app.store.dispatch(app.actions.session.updatesReceived(data));
                return data;
            })
            .catch((err) => {
                if (err?.response?.status == 403) {
                    console.warn('Invalid session');
                    handleLogout();
                } else {
                    throw err;
                }
            });
    },
};
